import React from "react";
import { Field, ErrorMessage } from "formik";
import { InputText } from "primereact/inputtext";
import { commonStyles } from "./types";

interface ContactSectionProps {
  isTrial: boolean;
  driver: any;
}

export const ContactSection: React.FC<ContactSectionProps> = ({ isTrial, driver }) => {
  const { inputClassName, labelClassName, errorClassName } = commonStyles;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
      <div className="field">
        <label htmlFor="email" className={labelClassName}>
          Email
        </label>
        <Field
          name="email"
          as={InputText}
          className={inputClassName}
          disabled={!!driver && isTrial}
        />
        <ErrorMessage
          name="email"
          component="small"
          className={errorClassName}
        />
      </div>

      <div className="field">
        <label htmlFor="phone" className={labelClassName}>
          Téléphone
        </label>
        <Field name="phone" as={InputText} className={inputClassName} />
        <ErrorMessage
          name="phone"
          component="small"
          className={errorClassName}
        />
      </div>
    </div>
  );
};
